import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのSettingsロゴアイコン
 */
export function ProductLogoSmallSettings({
  size = 20,
  color = "#646467",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3527 2.5C8.3527 2.22386 8.57655 2 8.8527 2H11.3527C11.6288 2 11.8527 2.22386 11.8527 2.5V3.73829C12.9211 4.03624 13.8785 4.60027 14.649 5.35446L15.7229 4.73446C15.962 4.59639 16.2678 4.67832 16.4059 4.91747L17.6559 7.08253C17.794 7.32168 17.712 7.62747 17.4729 7.76555L16.4004 8.38474C16.5325 8.90119 16.6027 9.44239 16.6027 10C16.6027 10.5576 16.5325 11.0988 16.4004 11.6153L17.4729 12.2345C17.712 12.3725 17.794 12.6783 17.6559 12.9175L16.4059 15.0825C16.2678 15.3217 15.962 15.4036 15.7229 15.2655L14.649 14.6455C13.8785 15.3997 12.9211 15.9638 11.8527 16.2617V17.5C11.8527 17.7761 11.6288 18 11.3527 18H8.8527C8.57655 18 8.3527 17.7761 8.3527 17.5V16.2617C7.28434 15.9638 6.32693 15.3997 5.55638 14.6455L4.48251 15.2655C4.24336 15.4036 3.93756 15.3217 3.79949 15.0825L2.54949 12.9175C2.41142 12.6783 2.49336 12.3725 2.73251 12.2345L3.80498 11.6153C3.67291 11.0988 3.6027 10.5576 3.6027 10C3.6027 9.44239 3.67291 8.90119 3.80498 8.38474L2.73251 7.76554C2.49336 7.62747 2.41142 7.32168 2.54949 7.08253L3.79949 4.91747C3.93756 4.67832 4.24336 4.59638 4.48251 4.73446L5.55638 5.35446C6.32693 4.60027 7.28434 4.03624 8.3527 3.73829V2.5ZM10.1027 12.5C11.4834 12.5 12.6027 11.3807 12.6027 10C12.6027 8.61929 11.4834 7.5 10.1027 7.5C8.72199 7.5 7.6027 8.61929 7.6027 10C7.6027 11.3807 8.72199 12.5 10.1027 12.5Z"
        fill={color}
      />
    </svg>
  );
}
